<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody />
 

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody />

            

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding: 10px;" >

                

                <div class="row mb-32 gy-8 dash-top">

                    <!-- POSTS -->
                    <div class="col-12 " >

                        <div class="row g-32" >

                            <div class="col-12 col-xl-8" style=" padding-bottom: 1000px; ">

                                <!-- <h2 class="mm-none" style="margin-top: -35px;"></h2> -->
                                <h2 class="dd-none" style="margin-top: -35px;"></h2>

                                
                                <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
                                    
                                    <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                    </symbol>

                                </svg>

                                <div v-if="regType == 'creator' && userType == 'user'" class="alert alert-warning alert-dismissible fade show d-fle align-items-cente" role="alert">

                                    <svg class="bi flex-shrink-0 me-8" width="24" height="24" role="img" aria-label="Info:"><use xlink:href="#exclamation-triangle-fill"/></svg>

                                        <router-link :to="{name: 'kyc'}" class="alert-link">Click here</router-link> to complete your creator application

                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>



                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12 ftab " id="myTab" role="tablist" style="margin-top: -10px">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="all-tab" data-bs-toggle="tab"
                                            data-bs-target="#all" role="tab" aria-controls="all" aria-selected="true"
                                            style="cursor: pointer;">For you</h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="following-tab" data-bs-toggle="tab"
                                            data-bs-target="#following" role="tab" aria-controls="following"
                                            aria-selected="false" style="cursor: pointer;">Following</h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="subscribed-tab" data-bs-toggle="tab"
                                            data-bs-target="#subscribed" role="tab" aria-controls="subscribed"
                                            aria-selected="false" style="cursor: pointer;">Subscribed</h6>
                                    </li>

                                    <!-- <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="sfw-tab" data-bs-toggle="tab" data-bs-target="#sfw"  role="tab" aria-controls="sfw" aria-selected="false" style="cursor: pointer;">SFW</h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="nsfw-tab" data-bs-toggle="tab" data-bs-target="#nsfw"  role="tab" aria-controls="nsfw" aria-selected="false" style="cursor: pointer;">NSFW</h6>
                                    </li> -->

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content" id="allTabContent" >
                                    <!-- ALL -->
                                    <div class="tab-pane fade show active"  id="all" role="tabpanel"
                                        aria-labelledby="all-tab" style="padding-bottom: 500px;  ">

                                        <div class="col-12" style="margin-bottom: 20px;"
                                            v-for="(post, index) in postListRaw" :key="'number' + index">

                                            <div class="card hp-card-4" v-if="post.isLoading">
                                                <div class="card-body">
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                    <br> <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                    </div>

                                                    <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                    </div>

                                                    <br> 
                                                    
                                                </div>
                                            </div>

                                            <div class="card hp-card-4" v-else>
                                                <div class="card-body">

                                                    <div class="row">

                                                        <div class="col">

                                                            <!-- <p class="hp-badge-text"
                                                                style="position: absolute; top: 30px; right: 50px; font-weight: 300;">
                                                                {{ post.dateD }}</p> -->

                                                            <i class="hp-text-color-dark-0 ri-2x ri-more-line" style="position: absolute; top: 24px; right: 20px; cursor: pointer;" data-bs-toggle="dropdown" ></i>

                                                            <ul class="dropdown-menu " style="cursor: pointer;">

                                                                <li @click="copy(post.id)" class="toast-btn" data-id="liveToast" id="liveToastBtn">
                                                                    <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" >

                                                                        <span class="submenu-item-icon">
                                                                            <i class="hp-text-color-dark-0 ri-2 ri-file-copy-line" style="font-size: 20px;"></i>
                                                                        </span>

                                                                        <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -7px; margin-left: 10px;">Copy link</span>
                                                                    </div>
                                                                </li>

                                                                <li >
                                                                    <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" @click="share(post.id)"> 
                                                                        <span class="submenu-item-icon">
                                                                            <i class="hp-text-color-dark-0 ri-2 ri-share-line" style="font-size: 20px;"></i>
                                                                        </span>
                                                                        
                                                                        <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Share</span>
                                                                    </div>
                                                                </li>

                                                                <li>
                                                                    <hr class="dropdown-divider">
                                                                </li>

                                                                <li data-bs-toggle="modal" data-bs-target="#reportModal" @click="reportClick(post.id)">
                                                                    <div class="dropdown-item text-danger"
                                                                        style="display: flex; justify-content: center; align-items: center;">
                                                                        <span class="submenu-item-icon">
                                                                            <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                style="font-size: 20px;"></i>
                                                                        </span>

                                                                        <span
                                                                            style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                    </div>
                                                                </li>


                                                            </ul>

                                                            <div class="row align-items-center">
                                                                <div class="w-auto px-0"
                                                                    @click="profileClick(post.userId, post.userName)"
                                                                    style="cursor: pointer;">
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                        style="width: 48px; height: 48px; ">
                                                                        <img :src="post.profilePic" class="hp-img-cover"
                                                                            style="width: 48px; height: 48px; background-color: black; object-fit: cover; border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                    </div>
                                                                </div>

                                                                <div class="w-auto ms-8 px-0 mt-12"
                                                                    @click="profileClick(post.userId, post.userName)">
                                                                    <span
                                                                        class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                        post.fullName }}

                                                                        <span v-if="post.userType == 'model'">
                                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 2px; margin-top: -3px;" > 
                                                                        </span> 

                                                                        <span v-if="post.sexuality == 'gay'">
                                                                            <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'lesbian'">
                                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'bisexual'">
                                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>
                                                                        
                                                                    </span>
                                                                    <p
                                                                        class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                        @{{ post.userName }}</p>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <p style="margin-top: 10px; margin-bottom: 5px; ">{{
                                                            post.caption }}</p>

                                                    </div>

                                                </div>

                                                <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.postType == 'paid' && post.isPaid && post.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 550px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="baesnap"
                                                                    style=" width: 100%; height: 550px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video webkit-playsinline="webkit-playsinline" controls 
                                                                    style="height: 550px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; " >
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline"
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList"   ></FsLightbox>

                                                    </div>

                                                    <div v-else-if="post.postType == 'paid' && !post.isPaid && post.isSubscribed" style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ post.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="post.isSubscribed || post.isOwner || post.postType == 'freex'"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video webkit-playsinline="webkit-playsinline" playsinline
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList"  ></FsLightbox>

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button  @click="subClick2(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                </div>

                                                <div
                                                    style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center;">

                                                        <div>

                                                            <div v-if="post.isLiked" :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                            <div v-else :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.likeCount }}
                                                        </span>

                                                        <div v-if="post.isBookmarked" :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <div v-else :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.bookmarkCount }}
                                                        </span>

                                                        <div v-if="post.commentCount > 0"
                                                            @click="commentClick(post, index)" data-bs-toggle="modal"
                                                            data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>

                                                        <div v-else @click="commentClick(post, index)"
                                                            data-bs-toggle="modal" data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>



                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.commentCount }}
                                                        </span>

                                                    </div>

                                                    <div>

                                                        <button @click="tipClick(post)"
                                                            class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle"
                                                            data-bs-toggle="modal" data-bs-target="#sendTip"
                                                            style="padding: 5px 10px; " v-if="!post.isOwner">
                                                            <span>&#8358;</span>

                                                        </button>

                                                    </div>

                                                    

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyAllHome2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyAllHome">
                                            <p class="hp-badge-text">No posts yet...</p>
                                        </div>

                                    </div>

                                    <!-- FOLLOWING -->
                                    <div class="tab-pane fade" id="following" role="tabpanel"
                                        aria-labelledby="following-tab" style="padding-bottom: 500px;">

                                        <div class="col-12" style="margin-bottom: 20px;"
                                            v-for="(post, index) in postListRaw2" :key="'number' + index">
                                            
                                            <div class="card hp-card-4" v-if="post.isLoading">
                                                <div class="card-body">
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                    <br> <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                    </div>

                                                    <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                    </div>

                                                    <br>
                                                    
                                                </div>
                                            </div>

                                            <div class="card hp-card-4" v-else>
                                                <div class="card-body">

                                                    <div class="row">

                                                        <div class="col">

                                                            <p class="hp-badge-text"
                                                                style="position: absolute; top: 30px; right: 20px; font-weight: 300;">
                                                                {{ post.dateD }}</p>

                                                            <div class="row align-items-center">
                                                                <div class="w-auto px-0"
                                                                    @click="profileClick(post.userId, post.userName)"
                                                                    style="cursor: pointer;">
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                        style="width: 48px; height: 48px; ">
                                                                        <img :src="post.profilePic" class="hp-img-cover"
                                                                            style="width: 48px; height: 48px; background-color: black; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                    </div>
                                                                </div>

                                                                <div class="w-auto ms-8 px-0 mt-12"
                                                                    @click="profileClick(post.userId, post.userName)">
                                                                    <span
                                                                        class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                        post.fullName }}
                                                                        
                                                                        <span v-if="post.userType == 'model'">
                                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 12px; height: 12px; margin-left: 2px; margin-top: -3px;" > 
                                                                        </span>

                                                                        <span v-if="post.sexuality == 'gay'">
                                                                            <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'lesbian'">
                                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'bisexual'">
                                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>
                                                                    </span>
                                                                    <p
                                                                        class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                        @{{ post.userName }}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <p v-if="post.previewUrl == ''"
                                                            style="margin-top: 30px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>
                                                        <p v-else style="margin-top: 10px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>



                                                    </div>

                                                </div>

                                                <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.postType == 'paid' && post.isPaid && post.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else-if="post.postType == 'paid' && !post.isPaid && post.isSubscribed" style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ post.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="post.isSubscribed || post.isOwner || post.postType == 'freex'"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="subClick2(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                </div>

                                                <div
                                                    style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center;">

                                                        <div>

                                                            <div v-if="post.isLiked" :id="post.idD + 'like'"
                                                                @click="likeClick2(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                            <div v-else :id="post.idD + 'like'"
                                                                @click="likeClick2(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.likeCount }}
                                                        </span>

                                                        <div v-if="post.isBookmarked" :id="post.idD + 'book'"
                                                            @click="bookClick2(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <div v-else :id="post.idD + 'book'"
                                                            @click="bookClick2(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.bookmarkCount }}
                                                        </span>

                                                        <div v-if="post.commentCount > 0"
                                                            @click="commentClick(post, index)" data-bs-toggle="modal"
                                                            data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>

                                                        <div v-else @click="commentClick(post, index)"
                                                            data-bs-toggle="modal" data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>



                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.commentCount }}
                                                        </span>

                                                    </div>

                                                    <div>

                                                        <button @click="tipClick(post)"
                                                            class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle"
                                                            data-bs-toggle="modal" data-bs-target="#sendTip"
                                                            style="padding: 5px 10px; " v-if="!post.isOwner">
                                                            <span>&#8358;</span>

                                                        </button>



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyFollowingHome2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite2" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;"
                                            id="emptyFollowingHome">
                                            <p class="hp-badge-text">No posts yet...</p>
                                        </div>

                                    </div>

                                    <!-- SUBSCRIBED -->
                                    <div class="tab-pane fade" id="subscribed" role="tabpanel"
                                        aria-labelledby="subscribed-tab" style="padding-bottom: 500px;">

                                        <div class="col-12" style="margin-bottom: 20px;"
                                            v-for="(post, index) in postListRaw3" :key="'number' + index">

                                            <div class="card hp-card-4" v-if="post.isLoading">
                                                <div class="card-body">
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                    <br> <br> 

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                    </div>

                                                    <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                    </div>

                                                    <br> 
                                                    
                                                </div>
                                            </div>

                                            <div class="card hp-card-4" v-else>
                                                <div class="card-body">

                                                    <div class="row">

                                                        <div class="col">

                                                            <p class="hp-badge-text"
                                                                style="position: absolute; top: 30px; right: 20px; font-weight: 300;">
                                                                {{ post.dateD }}</p>

                                                            <div class="row align-items-center">
                                                                <div class="w-auto px-0"
                                                                    @click="profileClick(post.userId, post.userName)"
                                                                    style="cursor: pointer;">
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                        style="width: 48px; height: 48px; ">
                                                                        <img :src="post.profilePic" class="hp-img-cover"
                                                                            style="width: 48px; height: 48px; background-color: black; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid;">
                                                                    </div>
                                                                </div>

                                                                <div class="w-auto ms-8 px-0 mt-12"
                                                                    @click="profileClick(post.userId, post.userName)">
                                                                    <span
                                                                        class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                        post.fullName }}
                                                                        
                                                                        <span v-if="post.userType == 'model'">
                                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 12px; height: 12px; margin-left: 2px; margin-top: -3px;" > 
                                                                        </span> 

                                                                        <span v-if="post.sexuality == 'gay'">
                                                                            <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'lesbian'">
                                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'bisexual'">
                                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>
                                                                        
                                                                    </span>
                                                                    <p
                                                                        class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                        @{{ post.userName }}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <p v-if="post.previewUrl == ''"
                                                            style="margin-top: 30px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>
                                                        <p v-else style="margin-top: 10px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>



                                                    </div>

                                                </div>

                                                <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.postType == 'paid' && post.isPaid && post.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else-if="post.postType == 'paid' && !post.isPaid && post.isSubscribed" style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ post.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="post.isSubscribed || post.isOwner || post.postType == 'freex'"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="subClick2(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                </div>

                                                <div
                                                    style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center;">

                                                        <div>

                                                            <div v-if="post.isLiked" :id="post.idD + 'like'"
                                                                @click="likeClick3(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                            <div v-else :id="post.idD + 'like'"
                                                                @click="likeClick3(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.likeCount }}
                                                        </span>

                                                        <div v-if="post.isBookmarked" :id="post.idD + 'book'"
                                                            @click="bookClick3(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <div v-else :id="post.idD + 'book'"
                                                            @click="bookClick3(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.bookmarkCount }}
                                                        </span>

                                                        <div v-if="post.commentCount > 0"
                                                            @click="commentClick(post, index)" data-bs-toggle="modal"
                                                            data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>

                                                        <div v-else @click="commentClick(post, index)"
                                                            data-bs-toggle="modal" data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>



                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.commentCount }}
                                                        </span>

                                                    </div>

                                                    <div>

                                                        <button @click="tipClick(post)"
                                                            class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle"
                                                            data-bs-toggle="modal" data-bs-target="#sendTip"
                                                            style="padding: 5px 10px; " v-if="!post.isOwner">
                                                            <span>&#8358;</span>

                                                        </button>



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptySubsHome2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite3" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;"
                                            id="emptySubsHome">
                                            <p class="hp-badge-text">No posts yet...</p>
                                        </div>

                                    </div>

                                    <!-- SFW -->
                                    <div class="tab-pane fade" id="sfw" role="tabpanel" aria-labelledby="sfw-tab"
                                        style="padding-bottom: 500px;">

                                        <div class="col-12" style="margin-bottom: 20px;"
                                            v-for="(post, index) in postListRaw4" :key="'number' + index">
                                            <div class="card hp-card-4">
                                                <div class="card-body">

                                                    <div class="row">

                                                        <div class="col">

                                                            <p class="hp-badge-text"
                                                                style="position: absolute; top: 30px; right: 20px; font-weight: 300;">
                                                                {{ post.dateD }}</p>

                                                            <div class="row align-items-center">
                                                                <div class="w-auto px-0"
                                                                    @click="profileClick(post.userId, post.userName)"
                                                                    style="cursor: pointer;">
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                        style="width: 48px; height: 48px; ">
                                                                        <img :src="post.profilePic" class="hp-img-cover"
                                                                            style="width: 48px; height: 48px; background-color: black; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                    </div>
                                                                </div>

                                                                <div class="w-auto ms-8 px-0 mt-12"
                                                                    @click="profileClick(post.userId, post.userName)">
                                                                    <span
                                                                        class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                        post.fullName }}
                                                                        <!-- <span>
                                                                                <img src="@/assets/img/check-circle.png" alt="" width="15px"> 
                                                                            </span>  -->
                                                                        <span v-if="post.sexuality == 'gay'">
                                                                            <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'lesbian'">
                                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'bisexual'">
                                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>
                                                                    </span>
                                                                    <p
                                                                        class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                        @{{ post.userName }}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <p v-if="post.previewUrl == ''"
                                                            style="margin-top: 30px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>
                                                        <p v-else style="margin-top: 10px; margin-bottom: -5px;">{{
                                                            post.caption }}</p>



                                                    </div>

                                                </div>

                                                <div style="width: 100%;height: 400px; position: relative;"
                                                    v-if="post.previewUrl != ''">

                                                    <img :src="post.previewUrl" alt=""
                                                        style=" height: 100%; width: 100%; object-fit: cover; ">

                                                    <div v-if="post.mediaList.length > 0"
                                                        style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;"
                                                        class="card-overlay"></div>

                                                    <div v-if="post.mediaList.length > 0">

                                                        <button v-if="post.isSubscribed || post.isOwner"
                                                            class="btn btn-icon-only rounded-circle btn-primary"
                                                            style=" color: #fff; position: absolute; top: 47%; left: 47% "
                                                            data-bs-toggle="modal" data-bs-target="#mediaGallery"
                                                            @click="galleryBtnClick(post)">
                                                            <i class="iconly-Light-Image"></i>
                                                        </button>

                                                        <button v-else @click="subClick(post)"
                                                            class="btn btn-icon-only rounded-circle btn-danger"
                                                            style="position: absolute; top: 47%; left: 47%; color: #fff;"
                                                            data-bs-toggle="modal" data-bs-target="#unlock1">
                                                            <i class="iconly-Light-Lock"></i>
                                                        </button>

                                                    </div>

                                                </div>

                                                <div
                                                    style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center;">

                                                        <div>

                                                            <div v-if="post.isLiked" :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                            <div v-else :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.likeCount }}
                                                        </span>

                                                        <div v-if="post.isBookmarked" :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <div v-else :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.bookmarkCount }}
                                                        </span>

                                                        <div v-if="post.commentCount > 0"
                                                            @click="commentClick(post, index)" data-bs-toggle="modal"
                                                            data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>

                                                        <div v-else @click="commentClick(post, index)"
                                                            data-bs-toggle="modal" data-bs-target="#comments"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i
                                                                class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                        </div>



                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.commentCount }}
                                                        </span>

                                                    </div>

                                                    <div>

                                                        <button @click="tipClick(post)"
                                                            class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle"
                                                            data-bs-toggle="modal" data-bs-target="#sendTip"
                                                            style="padding: 5px 10px; " v-if="!post.isOwner">
                                                            <span>&#8358;</span>

                                                        </button>



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite4" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                    </div>

                                    <div class="tab-pane fade" id="nsfw" role="tabpanel" aria-labelledby="nsfw-tab"
                                        style="padding-bottom: 500px;">
                                        <h1>NSFW</h1>
                                    </div>
                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4" >

                                <SuggestionsBody />

                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- CREATE -->

    <!-- MODALS -->
    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SUCCESS2 -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal2">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText2 }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS2">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SEND TIP -->
    <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="modelProfilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 style="text-align: center; width: 100%" class="modal-title">Send Tip</h4>

                    <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                        
                </div>

                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendTip">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="100 to 50,000"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Type a message here..." style="line-height: 20px; padding-top: 10px;"
                                v-model="message" maxlength="500"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer">

                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>



                </div>


            </div>
        </div>
    </div>

    <!-- MEDIA GALLERY -->
    <div class="modal fade" id="mediaGallery" tabindex="-1" aria-labelledby="mediaGalleryLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title">Media gallery ( @{{ modelUsername }} )</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        style="z-index: 5;"></button>
                </div>

                <div class="modal-body" style="margin-top: -30px;">


                    <!-- display -->
                    <div v-if="mediaUrl != ''"
                        style="display: flex; justify-content: center; align-items: center; margin-bottom:10px ;">

                        <video controls v-if="mediaType.startsWith('video')" class="shm">
                            <source :src="mediaUrl" type="video/mp4">
                            <source :src="mediaUrl" type="video/ogg">
                            <source :src="mediaUrl" type="video/webm">
                            <source :src="mediaUrl" type="video/3gp">
                            <source :src="mediaUrl" type="video/quicktime">
                            Your browser does not support the video tag.

                        </video>

                        <img :src="mediaUrl" alt="" v-else class="shm" style="object-fit: cover;">



                    </div>

                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>

                    <div class="d-flex align-items-center justify-content-center" style="flex-wrap: wrap;">



                        <!-- dupli img-->
                        <div v-for="(media, index) in mediaList" :key="index"
                            style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 5px; padding: 5px; margin-bottom: -5px;">

                            <div v-if="media.type.startsWith('image')" @click="playMedia(media)">
                                <img :src="media.url" alt=""
                                    style="width: 90px; height: 90px; object-fit: cover; border-radius: 5px; cursor: pointer;">

                                <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{
                                    fileSizeFormat(media.size) }} </p>
                            </div>

                            <div v-else
                                style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 5px; padding: 5px; margin-bottom: -5px;">

                                <div @click="playMedia(media)">
                                    <video
                                        style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover; position: relative;">
                                        <source :src="media.url" type="video/mp4">
                                        <source :src="media.url" type="video/ogg">
                                        <source :src="media.url" type="video/webm">
                                        <source :src="media.url" type="video/3gp">
                                        <source :src="media.url" type="video/quicktime">
                                        Your browser does not support the video tag.

                                    </video>

                                    <i class="hp-text-color-dark-0 position-absolute ri-2x ri-play-circle-fill"
                                        style="color: #fff; top: 25%; left: 35%; cursor: pointer;"></i>

                                    <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{
                                        fileSizeFormat(media.size) }} </p>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- <div class="modal-footer d-flex justify-content-center">
                            <button type="button" class="btn btn-primary" style="color: #fff;">Download all</button>
                        </div> -->


                </div>

            </div>
        </div>
    </div>

    <!-- SHOW -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 9999;" class="loadingModalBg"
        ref="showModal">
        <div class="col-12 col-xl-12 shx">
            <div class="card hp-card-6">
                <div class="card-body" style="position: relative;">

                    <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        style="position:absolute; top:10px; right: 10px;" @click="closeShow">
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>

                    <div class="row">

                        <h4 style="text-align: center;">{{ mediaName }}</h4>

                        <div style="display: flex; justify-content: center; align-items: center;">

                            <video controls v-if="mediaType.startsWith('video')" class="shm">
                                <source :src="mediaUrl" type="video/mp4">
                                <source :src="mediaUrl" type="video/ogg">
                                <source :src="mediaUrl" type="video/webm">
                                <source :src="mediaUrl" type="video/3gp">
                                <source :src="mediaUrl" type="video/quicktime">
                                Your browser does not support the video tag.

                            </video>

                            <img :src="mediaUrl" alt="" class="shm" v-else>



                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- UNLOCK1 -->
    <div class="modal fade" id="unlock2" tabindex="-1" aria-labelledby="unlock1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Subscribe to view</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        style="z-index: 5;"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body">Subscribe to gain full and unlimited access to all content from this model.
                        You can cancel your subscription at any time. </p>

                    <div @click="subscribe(30, mBundle1)" data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 30px 10px 15px 10px; background-color: #FF7F80; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">1 month</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ Number(mBundle1).toLocaleString("us-US")
                            }}</span>

                    </div>

                    <div @click="subscribe(90, mBundle2)" data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #FFC212; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">3 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ Number(mBundle2).toLocaleString("us-US")
                            }}</span>

                    </div>

                    <div @click="subscribe(180, mBundle3)" data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #C903FF; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">6 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ {{ Number(mBundle3).toLocaleString("us-US")
                            }}</span>

                    </div>

                </div>

                <!-- <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger">Close</button>
                    </div> -->
            </div>
        </div>
    </div>

    <!-- UNLOCK0 -->
    <div class="modal fade" id="unlock1" tabindex="-1" aria-labelledby="unlock1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Subscribe</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        style="z-index: 5;"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body">Subscribe to gain full access to content from @{{ mUsername }}</p>

                    <div data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 30px 10px 15px 10px; background-color: #FF7F80; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">1 month</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ 10,000</span>

                    </div>

                    <div data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #FFC212; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">3 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ 30,000</span>

                    </div>

                    <div data-bs-toggle="modal" data-bs-target="#unlock2"
                        class="d-flex justify-content-between align-items-center"
                        style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #C903FF; border-radius: 20px; cursor: pointer;">

                        <span class="hp-badge-text" style="color: #fff;">6 months</span>
                        <span class="hp-badge-text" style="color: #fff;">₦ 50,000</span>

                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>

                </div>
            </div>
        </div>
    </div>

    <!-- COMMENTS -->
    <div class="modal fade" id="comments" tabindex="-1" aria-labelledby="commentsLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">{{ commentCount }} Comments</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        style="z-index: 5;"></button>
                </div>

                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>

                <div class="modal-body" style="margin-top: -25px;">

                    <div id="comDiv"></div>

                    <div class="col-12" v-for="(com, index) in comments" :key="index">

                        <div class="row">
                            <div class="col-12" style="margin-bottom: 20px;">
                                <div
                                    style="justify-content: flex-start; display: flex; align-items: flex-start; width: 100%;">
                                    <div class="w-auto px-0" @click="profileClick(com.userId, com.userName)" data-bs-dismiss="modal">
                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                            style="width: 38px; height: 38px; ">
                                            <img :src="com.profilePic" class="hp-img-cover"
                                                style="width: 38px; height: 38px; background-color: black; object-fit: cover; ">
                                        </div>
                                    </div>

                                    <div class="w-auto ms-8 px-0 mt-4" style="width: 100%;">
                                        <p class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 mt-4 titleM"
                                            style="font-size: 14px; "> {{ com.name }} </p>
                                        <p style="font-size: 12px; margin-top: -5px; width: 100%; word-break: break-all;"
                                            class=" fw-normal hp-text-color-dark-30"> {{ com.comment }} </p>

                                        <p style="font-size: 9px; font-style: italic;"
                                            class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">{{ com.date }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div v-if="commentCount == 0" style="margin-top: 50px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                        <p class="hp-badge-text">No comments yet...</p>
                    </div>

                    <div v-if="commentCount > 20" style="margin-top: 0px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                        <button data-bs-dismiss="modal" class="btn btn-sm btn-primary" @click="postClick(postId)">Load more</button>
                    </div>

                </div>

                <form @submit.prevent="postComment" style="width: 100%; padding: 20px;">

                    <div
                        style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 0px;">

                        <div style="width: 100%; margin-right: 10px;">

                            <textarea style="line-height: 20px; padding-top: 10px;" name="description"
                                v-model="commentInput" maxlength="300" class="form-control" rows="3"
                                placeholder="Type comment here..." required></textarea>
                        </div>

                        <button class="btn btn-sm btn-icon-only rounded-circle btn-primary" id="commentBtn">
                            <i class="hp-text-color-dark-0 iconly-Light-Send"></i>
                        </button>

                        <!-- <button class="btn btn-sm btn-primary" style="color: #fff;" >Send</button> -->

                    </div>

                </form>


            </div>
        </div>
    </div>

    <!-- PPV -->
        <div class="modal fade" id="ppv" tabindex="-1" aria-labelledby="ppvLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Pay &#8358; {{ppvPost.priceD}} </h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <!-- <p class="hp-p1-body">Pay <strong></strong> to gain full access to this post </p> -->
                        
                        <div class="mb-24" style="margin-top: 10px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                    aria-describedby="basic-addon1" required v-model="password">

                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="ppv">Pay</button>
                    </div>
                </div>
            </div>
        </div>

    <!-- COPY TOAST -->
    <div class="position-fixed bottom-0 end-0 p-16" style="z-index: 99">
        <div data-id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" id="toastDiv" style="background-color: #e8def7; padding: 10px;">
            <div class="toast-header" style="background-color: #e8def7;">
                
                <strong class="me-auto">Baesnap</strong>
                <small>1 second ago</small>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>

            <div class="toast-body">
                {{toastMessage}}
            </div>
        </div>
    </div>

    <!-- REPORT -->
    <div class="modal fade" id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="centeredBackdropLabel">Report</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <form @submit.prevent="report">

                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="reportReason" id="reportReason1" checked v-model="reportReason" value="Violates Baesnap Terms of Service">
                            <label class="form-check-label" for="reportReason1">
                                Violates Baesnap Terms of Service
                            </label>
                        </div>

                        <div class="form-check" style="margin-top: 10px;">
                            <input class="form-check-input" type="radio" name="reportReason" id="reportReason2" v-model="reportReason" value="Contains copyrighted material (DMCA)">
                            <label class="form-check-label" for="reportReason2">
                                Contains copyrighted material (DMCA)
                            </label>
                        </div>

                        <div class="form-check" style="margin-top: 10px;">
                            <input class="form-check-input" type="radio" name="reportReason" id="reportReason3" v-model="reportReason" value="Child Sexual Abuse Material (CSAM)">
                            <label class="form-check-label" for="reportReason3">
                                Child Sexual Abuse Material (CSAM)
                            </label>
                        </div>

                        <div class="form-check" style="margin-top: 10px;">
                            <input class="form-check-input" type="radio" name="reportReason" id="reportReason4" v-model="reportReason" value="Report Spam">
                            <label class="form-check-label" for="reportReason4">
                                Report Spam
                            </label>
                        </div>

                        <div class="form-check" style="margin-top: 10px;">
                            <input class="form-check-input" type="radio" name="reportReason" id="reportReason5" v-model="reportReason" value="Report Abuse">
                            <label class="form-check-label" for="reportReason5">
                                Report Abuse
                            </label>
                        </div>

                        <div class="mb-24" style="margin-top: 30px;">
                            <label for="orderDetails" class="form-label"> Message <span class="text-danger me-4">*</span> </label>
                            <textarea name="orderDetails" id="orderDetails" class="form-control" rows="4" placeholder="Type here..." maxlength="300" required v-model="reportMessage" style="line-height: 20px; padding: 10px;"></textarea>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Report</button>
                        </div>

                        
                    </form>
                </div>

                
            </div>
        </div>
    </div>

    <!-- INFO -->
    <!-- INFO -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="infoModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            
                            <i class="hp-text-color-dark-0 ri-2x ri-file-info-line"></i>

                            <h4 class="mt-24 mb-16 me-4">Complete your profile</h4>
                            <p class="hp-p1-body mb-0" style="margin-top: 20px; font-size: 14px; text-align: start;"> Please update the following information: </p>

                            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 20px;" v-if="noProfilePic"> - Profile picture</span>
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 10px;" v-if="noProfileBack"> - Profile Background picture</span>
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 10px;" v-if="noBio"> - Bio</span>
                            </div>

                            <button class="btn btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 40px; margin-bottom: 10px;"
                                @click="closeI">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<style scoped>
.shx {
    width: 1000px;
}

.shm {
    max-width: 100%;
    max-height: 500px;
    object-fit: cover;
}

.ftab{
    overflow-x:auto;
    flex-wrap:nowrap; 
    scrollbar-width: none; 
    
}






@media only screen and (max-width: 666px) {

    .shx {
        width: 350px;

    }

    .shm {
        max-width: 100%;
        max-height: 700px;
        object-fit: cover;
    }

    .ftab{
        overflow-x:auto;
        flex-wrap:nowrap; 
        scrollbar-width: none; 
        
    }


}
</style>

<script>

import SidebarBody from '@/components/SidebarBody.vue';
import HeaderBody from '@/components/HeaderBody.vue';
import SuggestionsBody from '@/components/SuggestionsBody.vue';
import FooterBody from '@/components/FooterBody.vue';
import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
import "../../node_modules/v3-infinite-loading/lib/style.css";

import FsLightbox from "fslightbox-vue";

import LvSkeleton from "lightvue/skeleton";
import LvCodeLoader from 'lightvue/skeleton/preset/CodeLoader';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth"
import { db } from '@/firebase';
import axios from 'axios';
import { MD5 } from 'md5-js-tools';

export default {

    components: {
        SidebarBody,
        HeaderBody,
        SuggestionsBody,
        FooterBody,
        InfiniteLoading,
        FsLightbox,
        LvSkeleton,
        LvCodeLoader,
        
    },

    data() {
        return {
            toggler: false,
            loadingText: "",
            errorText: "",
            successText: "",
            successText2: "",

            balance: "",

            postId: "",
            postListRaw: [],
            postListRaw2: [],
            postListRaw3: [],
            postListRaw4: [],
            postListRaw5: [],
            postList: [],

            lastDocSnapshot: null,
            lastDocSnapshot2: null,
            lastDocSnapshot3: null,
            lastDocSnapshot4: null,
            lastDocSnapshot5: null,
            lastDocSnapshot6: null,

            isFirstPost: true,
            hasScrolledToBottom: false,

            modelUsername: "",
            mediaList: [],
            mediaName: "",
            mediaSize: "",
            mediaType: "",
            mediaUrl: "",

            commentPic: "",
            commentCount: "",
            comments: [],
            commentInput: "",
            postIndex: "",

            likeSpamList: [],
            bookSpamList: [],

            mBundle1: "",
            mBundle2: "",
            mBundle3: "",
            mProfilePic: "",
            mUsername: "",
            mName: "",
            mEmail: "",
            mModelId: "",

            tip: "",
            modelId: "",
            modelName: "",
            modelProfilePic: "",
            modelEmail: "",
            message: "",
            tipPostId: "",

            cModelId: "",

            followingList: [],
            subList: [],

            ppvPost: "",
            password: "",

            toastMessage: "",
            reportReason: "Violates Baesnap Terms of Service",
            reportMessage: "",
            rPostId: "",
            reportCount: 0,
            postObj: "",
            
            regType: "",
            userType: "",
            upline: "",
            uplineUserId: "",
            refCut: "",
            dateJoined: "",
            sexuality: "",

            profileComplete: true,
            noProfilePic: false,
            noProfileBack: false,
            noBio: false,

            videoObserver: null
        }
    },


    mounted() {

        document.body.style.overflowY = 'scroll';
        document.body.style.padding = '0px';
        document.getElementById("mobileLogo").style.display = 'none';
        document.getElementById("mobileTitle").textContent = "Baesnap"

        document.getElementById("homeN").classList.add("active");
        document.getElementById("homeN2").classList.add("active");

        this.regType = sessionStorage.getItem("regType");
        this.userType = sessionStorage.getItem("userType");

        localStorage.removeItem("otherUserName");
        localStorage.removeItem("otherId");
        

        this.getFollowing();
        this.getSubs();
        this.getRefCut();

        this.videoObserver = new MutationObserver(() => {
            this.hideDownloadButtons()
        })

        this.videoObserver.observe(document.body, {
            childList: true,
            subtree: true
        })

    },

    beforeUnmount(){
        if (this.videoObserver) {
            this.videoObserver.disconnect()
        }
    },

    methods: {

        async test2(){
            const auth = getAuth();
            const q = query(collection(db, "UserFollowing/"+auth.currentUser.uid+"/Following"), orderBy("timeStamp"), limit(10), startAfter(0));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());
            });
        },

        closeI() {
            this.$refs.infoModal.classList.remove("bg-active");
            this.$router.push({name: 'profile'});
        },

        async getRefCut(){
            const userRef = doc(db, "AdminInfo", "info");
            const userSnap = await getDoc(userRef);
            let rc = userSnap.data().refCut;
            this.refCut = Number(rc);

            if(sessionStorage.getItem("profilePic").includes("api.dicebear.com")){
                this.noProfilePic = true;
                this.profileComplete = false;
            }
            if(sessionStorage.getItem("profileBackground").includes("defaultBack2")){
                this.noProfileBack = true;
                this.profileComplete = false;
            }
            if(sessionStorage.getItem("bio") == ""){
                this.noBio = true;
                this.profileComplete = false;
            }

            if(!this.profileComplete && sessionStorage.getItem("userType") == "model" ){
                this.$refs.infoModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

        },

        hideDownloadButtons() {
            document.querySelectorAll('.fslightbox-container video').forEach(video => {
                video.setAttribute('controlsList', 'nodownload')
                video.setAttribute('disablePictureInPicture', '')
                video.oncontextmenu = () => false
            })
        },

        tipClick(post) {

            this.modelId = post.userId;
            this.modelName = post.fullName;
            this.modelUsername = post.userName;
            this.modelProfilePic = post.profilePic;
            this.tipPostId = post.id;
            this.modelEmail = post.email;
            this.postObj = post;

        },

        showToast(){
            $(".toast").each(function () {
                let eachItem = $(this), eachItemId = eachItem.data("id");

                if (eachItemId) {
                    new bootstrap.Toast($(this)).show();
                }
            });
        },

        reportClick(postId){
            this.rPostId = postId;
        },

        async report(){

            this.reportCount++

            if(this.reportCount > 4){
                return;
            }

            this.loadingText = "Reporting post";
            this.$refs.loadingModal.classList.add("bg-active");

            //add report
            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs;

            const auth = getAuth();

            await addDoc(collection(db, "UserReports"), {
                    
                title: this.reportReason,
                message: this.reportMessage,
                postId: this.rPostId,
                status: "pending",
                userId: auth.currentUser.uid,
                fullName: sessionStorage.getItem("fullName"),
                email: sessionStorage.getItem("email"),
                username: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
            });

            this.toastMessage = "Post reported successfully!";
            this.$refs.loadingModal.classList.remove("bg-active");
            this.showToast();

        },

        detectMob() {
            return ( ( window.innerWidth <= 800 ) );
        },

        async sendTip() {

            let balance, newBalance, uFullname, uEmail, uProfilePic, uUsername;

            this.loadingText = "Sendind tip to @" + this.modelUsername + "...";
            this.$refs.loadingModal.classList.add("bg-active");

            if (this.tip > 500000) {
                this.errorText = "Tips can not be larger than ₦ 500,000";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.tip < 1000) {
                this.errorText = "Minimum amount for tips is ₦ 1000";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            const auth = getAuth();

            //check balance
            if (auth.currentUser.uid == this.modelId) {
                this.errorText = "You can not send a tip to yourself...";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }


            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name;
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.tip) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            newBalance = balance - this.tip;

            await updateDoc(userRef, {
                balance: newBalance,
            });

            const modelRef = doc(db, "Users", this.modelId);
            const modelSnap = await getDoc(modelRef);
            if(modelSnap.exists()){
                this.dateJoined = modelSnap.data().dateJoined.seconds;
                this.upline = modelSnap.data().upline;
                this.sexuality = modelSnap.data().sexuality;
                this.userType = modelSnap.data().type;
            }

            const q = query(collection(db, "Users"), where("refCode", "==", this.upline));
            const idSnapshot = await getDocs(q);
            if(idSnapshot.docs.length > 0){
                idSnapshot.forEach((doc) => {
                    this.uplineUserId = doc.id;
                });

            }


            await updateDoc(modelRef, {
                earnings: increment(this.tip),
                tipBalance: increment(this.tip),
            });

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Sent tip",
                description: " Sent a tip of ₦ " + this.tip + " to @" + this.modelName,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.modelName,
                username: this.modelUsername,
                profilePic: this.modelProfilePic,
                
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Received tip",
                description: this.message,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: secs,
                status: "successful",
                userId: this.modelId,
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,
                

            });

            //model notification

            if (this.modelId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.modelId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Tips",
                    description: "Sent you a tip of ₦ " + this.tip,
                    ownerId: this.modelId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: this.tipPostId,
                });

            }

            if (this.message == "") {
                this.message = "none";
            }

            axios.post('https://api.baesnap.com/v1/tip-mail', {
                toName: this.modelName,
                toEmail: this.modelEmail,
                username: uUsername,
                amount: Number(this.tip).toLocaleString("us-Us"),
                message: this.message
            })
            .then(function (response) {
                console.log(response);

            })

            //REFF
            //check ref endDate
            let dateJoinedMili = Number(this.dateJoined) * 1000;
            let todayMili = Timestamp.now().seconds * 1000;

            let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

            if(Number(refDays) < 365 && this.upline != ""){

                if(this.uplineUserId == auth.currentUser.uid){
                    $('#sendTip').modal('hide');
                    this.successText2 = "Tip sent successfully";
                    this.$refs.successModal2.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                //update upline ref balance
                let mRefCut = this.refCut/100;
                let refAmount = Number(this.tip) * mRefCut;

                const usersRef = doc(db, "Users", this.uplineUserId);
                await updateDoc(usersRef, {
                    
                    refBalance: increment(refAmount),
                    
                });

                //update upline ref user
                const refUserRef = doc(db, "Referrals", this.modelId);
                await updateDoc(refUserRef, {
                    
                    refBalance: increment(refAmount),
                    
                });

                let mSecs = Timestamp.now().seconds;
                let secs = 10000000000 / mSecs;
                
                //update upline refTrans
                await addDoc(collection(db, "RefTrans"), {
                    type: "Deposit",
                    refAmount: refAmount,

                    fullName: this.modelName,
                    userName: this.modelUsername,
                    profilePic: this.modelProfilePic,
                    email: this.modelEmail,
                    userType: this.userType,
                    sexuality: this.sexuality,
                    userId: this.modelId,
                    timeStamp: serverTimestamp(),
                    timeStampN: secs,

                    status: "successful",
                    ownerId: this.uplineUserId
                });

            }


            $('#sendTip').modal('hide');
            this.successText2 = "Tip sent successfully";
            this.$refs.successModal2.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        share(postId){
            if(navigator.share){
                navigator.share({
                    text: "Check out my post on Baesnap",
                    url: "https://app.baesnap.com/post/"+postId,
                    title: "Baesnap | Post"
                })
            }
            else{
                    navigator.clipboard.writeText("https://app.baesnap.com/post/"+postId)
            }
        },

        

        copy(postId){
            this.toastMessage = "Link copied successfully!"
            let link = "https://app.baesnap.com/post/"+postId;
            navigator.clipboard.writeText(link);
            this.showToast(); 

        },

        subClick(post) {

            this.mBundle1 = post.bundle1;
            this.mBundle2 = post.bundle2;
            this.mBundle3 = post.bundle3;
            this.mUsername = post.userName;
            this.mModelId = post.userId;
            this.mEmail = post.email;

        },

        subClick2(post){
            sessionStorage.setItem("otherId", post.userId);
            this.$router.push({name: 'sub-pay'});
        },

        ppvClick(post){
            this.ppvPost = post;
            $('#ppv').modal('show');
        },

        ppv(){

            this.loadingText = "Authenticating...";
            this.$refs.loadingModal.classList.add("bg-active");

            
            if(this.password == ""){
                this.errorText = "Please enter your password to proceed.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            let passwordHash = MD5.generate(String(this.password));

            const auth = getAuth();
            const user = auth.currentUser;

            if(this.ppvPost.userId == auth.currentUser.uid){
                return;
            }

            const credential = EmailAuthProvider.credential( sessionStorage.getItem("email"), passwordHash );

            reauthenticateWithCredential(user, credential)
            .then((result) => {
                //password correct
                this.ppv2();

            })
            .catch((error) => {
                //console.log(error);
                this.errorText = "Incorrect password...";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;

            });
        },

        async ppv2(){
            let balance, newBalance, uFullname, uEmail, uUsername, uProfilePic;

            const auth = getAuth();
            this.loadingText = "Processing transaction...";

            //check balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uFullname = userSnap.data().name;
                uUsername = userSnap.data().displayId;
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.ppvPost.price) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            await updateDoc(userRef, {
                balance: increment(-this.ppvPost.price),
            });

            //update model balance
            const modelRef = doc(db, "Users", this.ppvPost.userId);
            await updateDoc(modelRef, {
                earnings: increment(this.ppvPost.price),
                ppvBalance: increment(this.ppvPost.price),
            });

            //add to paidUsers
            await setDoc(doc(db, "UserPosts", this.ppvPost.id, "PaidUsers", auth.currentUser.uid), {});

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs;

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Paid post",
                description: " Paid to view post",
                amount: this.ppvPost.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.ppvPost.fullName,
                username: this.ppvPost.userName,
                profilePic: this.ppvPost.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Paid post",
                description: "@" + uUsername + " paid to view your post",
                amount: this.ppvPost.price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: this.ppvPost.userId,
                
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,

            });

            // NOTIFICATION
            if (this.ppvPost.userId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.ppvPost.userId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Paid posts",
                    description: "Paid for your post",
                    ownerId: this.ppvPost.userId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: this.ppvPost.id,
                });

            }

            axios.post('https://api.baesnap.com/v1/new-ppv-mail', {
                toName: this.ppvPost.fullName,
                toEmail: this.ppvPost.email,
                username: "@" + uUsername,
                amount: this.ppvPost.priceD,
                
            })
            .then(function (response) {
                //console.log(response);
            })

            $('#ppv').modal('hide');

            this.successText = "The transaction was completed successfully. You now have full access to the post.";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async subscribe(days, price) {

            let balance, newBalance, uUsername, uFullname, uEmail, uProfilePic;

            const auth = getAuth();

            this.loadingText = "Subscribing to @" + this.mUsername + " for " + days + " days...";
            this.$refs.loadingModal.classList.add("bg-active");

            const typeRef = doc(db, "Users", this.mModelId);
            const typeSnap = await getDoc(typeRef);

            if (typeSnap.exists()) {
                if (typeSnap.data().type == "user") {
                    this.loadingText = "";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.loadingText = "";
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            //check balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name,
                    uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < Number(price)) {
                    this.errorText = "Insufficient balance. Please fund your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            let todaySecs = new Date().getTime() / 1000;
            let durationSecs = Number(days) * 24 * 60 * 60;
            let endDateSecs = todaySecs + durationSecs;

            newBalance = balance - Number(price);

            await updateDoc(userRef, {
                balance: newBalance,
            });

            //update model balance
            const modelRef = doc(db, "Users", this.mModelId);
            await updateDoc(modelRef, {
                earnings: increment(Number(price)),
                fanCount: increment(1),
                fanCountN: increment(-1)
            });

            //update model fan list
            await setDoc(doc(db, "UserFans", this.mModelId, "Fans", auth.currentUser.uid,), {
                price: Number(price),
                startDate: serverTimestamp(),
                duration: Number(days),
                endDate: endDateSecs,
                status: "active",
                userId: auth.currentUser.uid,
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,
                email: uEmail,
            });

            //update user sub list
            await setDoc(doc(db, "UserSubs", auth.currentUser.uid, "Subs", this.mModelId), {
                price: Number(price),
                startDate: serverTimestamp(),
                duration: Number(days),
                endDate: endDateSecs,
                status: "active",
                modelId: this.mModelId,
                modelName: this.mName,
                modelUserName: this.mUsername,
                modelProfilePic: this.mProfilePic,
                email: this.mEmail,
            });

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Subscription",
                description: " Subscribed to @" + this.mUsername + " for " + days + " days",
                amount: price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                
                fullName: this.mName,
                username: this.mUsername,
                profilePic: this.mProfilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Subscription",
                description: "@" + uUsername + " subscribed to your content for " + days + " days",
                amount: price,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: this.mModelId,
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,

            });

            // NOTIFICATION
            if (this.mModelId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.mModelId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Subs",
                    description: "Subscribed to your content for " + days + " at ₦ " + price,
                    ownerId: this.mModelId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }

            axios.post('https://api.Baesnap.com/v1/new-sub-mail', {
                toName: this.mName,
                toEmail: this.mEmail,
                username: "@" + uUsername,
                amount: Number(price).toLocaleString("us-Us"),
                duration: days,
            })
                .then(function (response) {
                    console.log(response);

                })


            this.successText = "Successfully Subscribed to @" + this.mUsername + " for " + days + " days";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        profileClick(userId, userName) {

            const auth = getAuth();

            if (auth.currentUser.uid == userId) {
                this.$router.push({ name: 'profile' });
                return;
            }

            sessionStorage.setItem("otherId", userId);
            this.$router.push({ name: 'other-profile', params: { id: userName } });
            return;

        },

        postClick(postId){

            this.$router.push({ name: 'post', params: { id: postId } });
            return;

        },

        async getFollowing() {

            

            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFollowing", auth.currentUser.uid, "Following"), limit(50));
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    this.followingList.push(doc.id);
                })

            }

        },

        async getSubs() {
            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserSubs", auth.currentUser.uid, "Subs"), limit(100));
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    this.subList.push(doc.id);
                })

            }
        },

        async commentClick(post, index) {

            this.commentCount = post.commentCount;
            this.postId = post.id;
            this.cModelId = post.userId;
            this.postIndex = index;

            this.comments = [];
            this.commentInput = "";

            const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
                this.comments.push({
                    userId: doc.data().userId,
                    profilePic: doc.data().profilePic,
                    name: doc.data().name,
                    userName: doc.data().userName,
                    comment: doc.data().comment,
                    date: doc.data().date,
                });
            });

        },

        async getComments(){

            let res = [];
            const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20), startAfter(this.lastDocSnapshot6 || 0));
            
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot6 = querySnapshot.docs[querySnapshot.docs.length - 1];

            if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let result = {
                            userId: doc.data().userId,
                            profilePic: doc.data().profilePic,
                            name: doc.data().name,
                            userName: doc.data().userName,
                            comment: doc.data().comment,
                            date: doc.data().date,
                        }

                        this.comments.push(result);

                    })

                    
                }

                return res.length;

        },

        async postComment() {

            document.getElementById("commentBtn").disabled = true;
            this.commentCount++;
            const auth = getAuth();

            let a = String(new Date());

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs;

            //update list
            let commentObj = {
                userId: auth.currentUser.uid,
                profilePic: sessionStorage.getItem("profilePic"),
                name: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                comment: this.commentInput,
                date: a.slice(0, -36),
                dateN: secs
            }

            this.comments.unshift(commentObj);
            document.getElementById("comDiv").scrollIntoView();

            //update post comment db
            const postRef = doc(db, "UserPosts", this.postId);
            await updateDoc(postRef, {

                commentCount: increment(1),

            });

            await addDoc(collection(db, "UserPosts", this.postId, "Comments"), {
                userId: auth.currentUser.uid,
                profilePic: sessionStorage.getItem("profilePic"),
                name: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                comment: this.commentInput,
                date: a.slice(0, -36),
                dateN: secs
            });


            document.getElementById("commentBtn").disabled = false;
            this.postListRaw[this.postIndex].commentCount++;

            // NOTIFICATION
            if (this.cModelId != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", this.cModelId);
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs
                await addDoc(collection(db, "UserNoti"), {
                    category: "Comments",
                    description: "Commented on your post: " + this.commentInput,
                    ownerId: this.cModelId,
                    userId: auth.currentUser.uid,
                    username: sessionStorage.getItem("userName"),
                    fullName: sessionStorage.getItem("fullName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                    email: sessionStorage.getItem("email"),
                    date: serverTimestamp(),
                    postId: this.postId,
                    dateN: secs
                });

            }

            this.commentInput = "";

        },

        downloadAll(mediaList) {

            mediaList.forEach(function (e) {
                fetch(e.url)
                    .then(res => res.blob())
                    .then(blob => {
                        saveAs(blob, e.name);
                    });
            });

        },

        galleryBtnClick(post) {

            this.mediaUrl = post.mediaList[0].url;
            this.mediaType = post.mediaList[0].type;
            this.modelUsername = post.userName;
            this.mediaList = post.mediaList;

        },

        playMedia(media) {


            this.mediaName = media.name;
            this.mediaType = media.type;
            this.mediaUrl = media.url;
            this.mediaSize = media.size;
            //this.$refs.showModal.classList.add("bg-active");

        },

        getOccurrence(array, value) {
            var count = 0;
            array.forEach((v) => (v === value && count++));
            return count;
        },

        async likeClick(id, index, post) {

            const auth = getAuth();

            this.likeSpamList.push(post.id);

            $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            //update list
            if (post.isLiked) {
                this.postListRaw[index].likeCount--;
                this.postListRaw[index].isLiked = false;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(-1),
                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(-1),
                    likesN: increment(1)
                });

                await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
            }

            else {
                this.postListRaw[index].likeCount++;
                this.postListRaw[index].isLiked = true;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(1),

                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(1),
                    likesN: increment(-1)
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Likes",
                        description: "Liked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs,
                    });

                }

            }

        },

        async bookClick(id, index, post) {

            $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            const auth = getAuth();

            this.bookSpamList.push(post.id);

            //update list
            if (post.isBookmarked) {
                this.postListRaw[index].bookmarkCount--;
                this.postListRaw[index].isBookmarked = false;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(-1),

                });

                await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                //remove bookmark post
                await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
            }

            else {
                this.postListRaw[index].bookmarkCount++;
                this.postListRaw[index].isBookmarked = true;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(1),

                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                //add post to bookmark
                await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Bookmarks",
                        description: "Bookmarked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs
                    });

                }

            }
        },

        async likeClick2(id, index, post) {

            const auth = getAuth();

            this.likeSpamList.push(post.id);

            $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            //update list
            if (post.isLiked) {
                this.postListRaw2[index].likeCount--;
                this.postListRaw2[index].isLiked = false;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(-1),
                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(-1),
                    likesN: increment(1)
                });

                await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
            }

            else {
                this.postListRaw2[index].likeCount++;
                this.postListRaw2[index].isLiked = true;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(1),

                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(1),
                    likesN: increment(-1)
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Likes",
                        description: "Liked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs,
                    });

                }

            }

        },

        async bookClick2(id, index, post) {

            $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            const auth = getAuth();

            this.bookSpamList.push(post.id);

            //update list
            if (post.isBookmarked) {
                this.postListRaw2[index].bookmarkCount--;
                this.postListRaw2[index].isBookmarked = false;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(-1),

                });

                await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                //remove bookmark post
                await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
            }

            else {
                this.postListRaw2[index].bookmarkCount++;
                this.postListRaw2[index].isBookmarked = true;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(1),

                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                //add post to bookmark
                await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Bookmarks",
                        description: "Bookmarked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs
                    });

                }

            }
        },

        async likeClick3(id, index, post) {

            const auth = getAuth();

            this.likeSpamList.push(post.id);

            $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            //update list
            if (post.isLiked) {
                this.postListRaw3[index].likeCount--;
                this.postListRaw3[index].isLiked = false;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(-1),
                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(-1),
                    likesN: increment(1)
                });

                await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
            }

            else {
                this.postListRaw3[index].likeCount++;
                this.postListRaw3[index].isLiked = true;

                if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    likeCount: increment(1),

                });

                const userRef = doc(db, "Users", post.userId);
                await updateDoc(userRef, {
                    likes: increment(1),
                    likesN: increment(-1)
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Likes",
                        description: "Liked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs,
                    });

                }

            }

        },

        async bookClick3(id, index, post) {

            $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
            $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

            const auth = getAuth();

            this.bookSpamList.push(post.id);

            //update list
            if (post.isBookmarked) {
                this.postListRaw3[index].bookmarkCount--;
                this.postListRaw3[index].isBookmarked = false;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(-1),

                });

                await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                //remove bookmark post
                await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
            }

            else {
                this.postListRaw3[index].bookmarkCount++;
                this.postListRaw3[index].isBookmarked = true;

                if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                    return;
                }

                const postRef = doc(db, "UserPosts", post.id);
                await updateDoc(postRef, {
                    bookmarkCount: increment(1),

                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                //add post to bookmark
                await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                    timeStamp: serverTimestamp(),
                    timeStampN: secs
                });

                // NOTIFICATION
                if (post.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", post.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Bookmarks",
                        description: "Bookmarked your post",
                        ownerId: post.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: post.id,
                        dateN: secs
                    });

                }

            }
        },

        async test() {

            let test = (await this.getUserInfoPost('TFCoaCOOZBUVinAWl8908DwL00D3')).profilePic;

            console.log(test);

        },

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        closeS2() {
            this.$refs.successModal2.classList.remove("bg-active");
            //this.$router.go();
        },

        closeShow() {
            this.mediaName = "";
            this.mediaType = "";
            this.mediaUrl = "";
            this.mediaSize = "";
            this.$refs.showModal.classList.remove("bg-active");
            return;

        },

        fileSizeFormat(fileSize) {
            let mSize;
            if (Number(fileSize) >= 1073741824) {
                mSize = (Number(fileSize) / 1073741824).toFixed(2) + " GB";
            }
            else if (Number(fileSize) >= 1048576) {
                mSize = (Number(fileSize) / 1048576).toFixed(2) + " MB";
            }
            else if (Number(fileSize) >= 1024) {
                mSize = (Number(fileSize) / 1024).toFixed(2) + " KB";
            }

            return mSize;
        },

        timeFormat(date) {

            let newFormat;

            TimeAgo.addDefaultLocale(en);
            const timeAgo = new TimeAgo('en-US');
            newFormat = timeAgo.format(Number(date));

            return newFormat;

        },

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        async getPosts() {

            //start loading
            this.loadingText = "Please wait...";
            this.$refs.loadingModal.classList.add("bg-active");

            // let postRef = db.collection('UserPosts').limit(10);

            const q = query(collection(db, "UserPosts"));
            let result;
            const querySnapshot = await getDocs(q);

            if (querySnapshot.docs.length > 0) {

                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                querySnapshot.forEach((doc) => {

                    result = querySnapshot.docs.map(p => p.data());
                    this.postListRaw.push(...result);

                })
            }

            console.log("POSTLIST " + result.length, this.postListRaw);
            this.$refs.loadingModal.classList.remove("bg-active");

            return result.length;

        },

        async getFirstPosts() {

            //start loading
            this.loadingText = "Getting posts...";
            this.$refs.loadingModal.classList.add("bg-active");

            const q = query(collection(db, "UserPosts"), orderBy('timeStamp'), limit(10));
            const querySnapshot = await getDocs(q);

            this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {
                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: (await this.getUserInfoPost(doc.data().userId)).fullName,
                        userName: (await this.getUserInfoPost(doc.data().userId)).userName,
                        email: (await this.getUserInfoPost(doc.data().userId)).email,
                        profilePic: (await this.getUserInfoPost(doc.data().userId)).profilePic,
                        isOwner: (await this.getUserInfoPost(doc.data().userId)).isOwner,
                        isSubscribed: (await this.getUserInfoPost(doc.data().userId)).isSubscribed,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),


                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: await this.getLikedStatus(doc.data().likedList),
                        isBookmarked: await this.getBookmarkStatus(doc.data().bookmarkList),

                        likeCount: this.kFormatter(doc.data().likeCount),
                        bookmarkCount: this.kFormatter(doc.data().bookmarkCount),
                        commentCount: this.kFormatter(doc.data().commentCount),

                        likedList: doc.data().likedList,
                        bookmarkList: doc.data().bookmarkList,
                        comments: doc.data().comments,


                    }

                    this.postListRaw.push(result);

                })


            }

            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async getNextPosts() {

            let res = [];

            const q = query(collection(db, "UserPosts"), where("postType", "==", "freex"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;
                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {
                        isLoading: true,

                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: doc.data().fullName,
                        userName: doc.data().username,
                        profilePic: doc.data().profilePic,
                        email: doc.data().email,
                        sexuality: "",
                        bundle1: 0,
                        bundle2: 0,
                        bundle3: 0,

                        isOwner: false,
                        isSubscribed: false,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),

                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: doc.data().likeCount,
                        bookmarkCount: doc.data().bookmarkCount,
                        commentCount: doc.data().commentCount,

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],

                        postType: doc.data().postType,
                        isPaid: false,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),

                        userType: "",
                        profileType: ""

                    }

                    this.postListRaw.push(result);

                    let mIndex = this.postListRaw.length - 1;

                    await this.getFullName(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);

                })


            }


            return res.length;

        },

        async getFollowingPosts() {

            let res = [];
            const q = query(collection(db, "UserPosts"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot2 || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;
                    
                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {

                        isLoading: true,

                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: doc.data().fullName,
                        userName: doc.data().username,
                        profilePic: doc.data().profilePic,
                        email: doc.data().email,
                        sexuality: "",
                        bundle1: 0,
                        bundle2: 0,
                        bundle3: 0,

                        isOwner: false,
                        isSubscribed: false,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),

                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: doc.data().likeCount,
                        bookmarkCount: doc.data().bookmarkCount,
                        commentCount: doc.data().commentCount,

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],

                        postType: doc.data().postType,
                        isPaid: false,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),
                        userType: "",
                        profileType: ""

                    }

                    if (this.getOccurrence(this.followingList, doc.data().userId) > 0) {
                        this.postListRaw2.push(result);
                        let mIndex = this.postListRaw2.length -1;
                        this.getFullName2(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);
                    }

                })

            }


            return res.length;

        },

        async getSubPosts() {

            let res = [];
            const q = query(collection(db, "UserPosts"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot3 || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot3 = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;

                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {

                        isLoading: true,

                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: doc.data().fullName,
                        userName: doc.data().username,
                        profilePic: doc.data().profilePic,
                        email: doc.data().email,
                        sexuality: "",
                        bundle1: 0,
                        bundle2: 0,
                        bundle3: 0,

                        isOwner: false,
                        isSubscribed: false,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),

                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: doc.data().likeCount,
                        bookmarkCount: doc.data().bookmarkCount,
                        commentCount: doc.data().commentCount,

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],

                        postType: doc.data().postType,
                        isPaid: false,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),
                        userType: "",
                        profileType: ""


                    }

                    if (this.getOccurrence(this.subList, doc.data().userId) > 0) {
                        this.postListRaw3.push(result);
                        let mIndex = this.postListRaw3.length - 1;
                        this.getFullName3(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);
                    }

                    

                })

            }

            return res.length;

        },

        async getSFWPosts() {

            let res = [];
            const q = query(collection(db, "UserPosts"), where("category", "==", "sfw"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot4 || 0));
            const querySnapshot = await getDocs(q);

            res = querySnapshot.docs.map(p => p.data());
            this.lastDocSnapshot4 = querySnapshot.docs[querySnapshot.docs.length - 1];

            if (res.length > 0) {

                querySnapshot.forEach(async (doc) => {

                    let urlList = [];
                    let imgCount = 0;
                    let vidCount = 0;

                    let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                    let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                    let result = {
                        id: doc.id,
                        idD: doc.data().idD,
                        userId: doc.data().userId,
                        fullName: doc.data().fullName,
                        userName: doc.data().username,
                        profilePic: doc.data().profilePic,
                        email: doc.data().email,
                        sexuality: "",
                        bundle1: 0,
                        bundle2: 0,
                        bundle3: 0,

                        isOwner: false,
                        isSubscribed: false,
                        tags: doc.data().tags,
                        caption: doc.data().caption,
                        category: doc.data().category,

                        timeStamp: doc.data().timeStamp,
                        dateFull: a2.slice(0, -36),
                        dateD: this.timeFormat(a1),

                        price: doc.data().price,
                        previewUrl: doc.data().previewUrl,
                        mediaList: doc.data().mediaList,

                        isLiked: false,
                        isBookmarked: false,

                        likeCount: doc.data().likeCount,
                        bookmarkCount: doc.data().bookmarkCount,
                        commentCount: doc.data().commentCount,

                        toggler: false,
                        urlList: urlList,
                        imgCount: imgCount,
                        vidCount: vidCount,
                        previewUrl2: [doc.data().previewUrl],

                        postType: doc.data().postType,
                        isPaid: false,
                        priceD: Number(doc.data().price).toLocaleString("us-US"),

                        userType: "",
                        profileType: ""


                    }

                    this.postListRaw4.push(result);

                    this.getFullName4(doc.id, doc.data().userId);

                })


            }


            return res.length;

        },

        async getUserInfoPost(userId) {

            let isOwner = false;
            let isSubscribed = false;
            let fanList = [];

            const auth = getAuth();

            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });


            //check if owner
            if (auth.currentUser.uid == userId) {
                isOwner = true;
                isSubscribed = true;
            }
            else {
                for (let i = 0; i < fanList.length; i++) {
                    if (fanList[i] == auth.currentUser.uid) {
                        isSubscribed = true;
                    }
                }
            }

            return {
                profilePic: userSnap.data().profilePic,
                fullName: userSnap.data().name,
                userName: userSnap.data().displayId,
                email: userSnap.data().email,
                userType: userSnap.data().type,
                isOwner: isOwner,
                isSubscribed: isSubscribed,
            }

        },

        async getLikedStatus(postId) {

            let likedList = [];
            const auth = getAuth();

            const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "LikedList"));
            querySnapshot.forEach((doc) => {
                likedList.push(doc.id);
            });

            for (let i = 0; i < likedList.length; i++) {
                if (likedList[i] == auth.currentUser.uid) {
                    return true
                }
            }

            return false;

        },

        async getBookmarkStatus(postId) {

            const auth = getAuth();
            let bookmarkList = [];

            const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "BookmarkList"));
            querySnapshot.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            for (let i = 0; i < bookmarkList.length; i++) {
                if (bookmarkList[i] == auth.currentUser.uid) {
                    return true
                }
            }

            return false;

        },

        async handleInfinite($state) {

            const newPostCount = await this.getNextPosts();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            if (this.postListRaw.length == 0) {
                document.getElementById("emptyAllHome").style.display = "flex";

            }

            //no more posts
            document.getElementById("emptyAllHome2").style.display = "none";

            //no more posts
            return $state.complete();

        },

        async handleInfinite2($state) {

            const newPostCount = await this.getFollowingPosts();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            if (this.postListRaw2.length == 0) {
                document.getElementById("emptyFollowingHome").style.display = "flex";

            }

            //no more posts
            document.getElementById("emptyFollowingHome2").style.display = "none";

            //no more posts
            return $state.complete();

        },

        async handleInfinite3($state) {

            const newPostCount = await this.getSubPosts();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            if (this.postListRaw3.length == 0) {
                document.getElementById("emptySubsHome").style.display = "flex";

            }

            //no more posts
            document.getElementById("emptySubsHome2").style.display = "none";

            //no more posts
            return $state.complete();

        },

        async handleInfinite4($state) {

            const newPostCount = await this.getSFWPosts();

            if (newPostCount > 0) {
                //more posts
                return $state.loaded();
            }

            //no more posts
            return $state.complete();

        },

        async handleInfinite5($state){

            const newPostCount = await this.getComments();

            if(newPostCount > 0 ){
                //more posts
                return $state.loaded();
            }

            

            //no more posts
            document.getElementById("emptyComment2").style.display = "none";
            return $state.complete();

        },

        async videoUrlToBase64(url) {
            try {
                // Fetch the video as a Blob
                const response = await fetch(url);
                if (!response.ok) throw new Error('Network response was not ok');

                const blob = await response.blob();

                console.log("BLOBB :"+blob)
                // Create a FileReader to convert Blob to Base64
                const reader = new FileReader();
                
                return new Promise((resolve, reject) => {
                    reader.onloadend = () => {
                        // The result will be in the format: data:video/mp4;base64,...
                        resolve(reader.result);
                    };
                    reader.onerror = () => reject(new Error('Error reading blob'));
                    reader.readAsDataURL(blob);
                });
            } catch (error) {
                console.error('Error converting video URL to Base64:', error);
                return null;
            }
        },

        getThumbnail(videoUrl){

            let thumbnail;
            const video = document.getElementById("videoGif2");
            video.src = videoUrl;
            video.currentTime = 2; // Start from the beginning

            video.addEventListener('loadeddata', () => {
                const canvas = document.getElementById('canvasGif2');
                const ctx = canvas.getContext('2d');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                // Draw the video frame to the canvas
                ctx.drawImage(video, 0, 0);

                // Convert the canvas to a data URL and set it as the source for the poster image
                // const posterImage = document.getElementById('posterImage');
                thumbnail =  canvas.toDataURL('image/png');

                //console.log("DATA URL"+canvas.toDataURL('image/png'));

                // Clean up
                URL.revokeObjectURL(video.src);

                return thumbnail;

            });

            video.play();

        },

        async getFullName(id, userId, mediaList, previewUrl, mIndex) {

            let i = mIndex;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            let urlList = [];
            let imgCount = 0;
            let vidCount = 0;

            for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                if (mediaList[a].type.startsWith("image")) {
                    imgCount++;
                }
                else if (mediaList[a].type.startsWith("video")) {
                    vidCount++;
                }
            }

            if(mediaList.length < 1){
                urlList.push(previewUrl);
            }

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            if (this.postListRaw[i].id == id) {
                    
                    this.postListRaw[i].fullName = userSnap.data().name;
                    this.postListRaw[i].userName = userSnap.data().displayId;
                    this.postListRaw[i].profilePic = userSnap.data().profilePic;
                    this.postListRaw[i].email = userSnap.data().email;
                    this.postListRaw[i].bundle1 = userSnap.data().bundle1;
                    this.postListRaw[i].bundle2 = userSnap.data().bundle2;
                    this.postListRaw[i].bundle3 = userSnap.data().bundle3;
                    this.postListRaw[i].sexuality = userSnap.data().sexuality;
                    this.postListRaw[i].userType = userSnap.data().type;
                    this.postListRaw[i].profileType = userSnap.data().profileType;

                    this.postListRaw[i].urlList = urlList;
                    this.postListRaw[i].vidCount = vidCount;
                    this.postListRaw[i].imgCount = imgCount;

                    if (auth.currentUser.uid == userId) {
                        this.postListRaw[i].isOwner = true;
                        this.postListRaw[i].isSubscribed = true;
                        this.postListRaw[i].isPaid = true;
                    }
                    else if (userSnap.data().type == "user") {
                        this.postListRaw[i].isSubscribed = true;
                    }
                    else if (userSnap.data().profileType == "free") {
                        this.postListRaw[i].isSubscribed = true;
                    }
                    else {
                        for (let b = 0; b < fanList.length; b++) {
                            if (fanList[b] == auth.currentUser.uid) {
                                this.postListRaw[i].isSubscribed = true;
                                break;
                            }
                        }
                    }

                    for (let c = 0; c < likedList.length; c++) {
                        if (likedList[c] == auth.currentUser.uid) {
                            this.postListRaw[i].isLiked = true;
                            break;
                        }
                    }

                    for (let d = 0; d < bookmarkList.length; d++) {
                        if (bookmarkList[d] == auth.currentUser.uid) {
                            this.postListRaw[i].isBookmarked = true;
                            break;
                        }
                    }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postListRaw[i].isPaid = true;
                            break;
                        }
                    }

                    this.postListRaw[i].isLoading = false;

                }

        },

        async getFullNamexo(id, userId, mediaList, previewUrl) {

            let index;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];

            let urlList = [];
            let imgCount = 0;
            let vidCount = 0;

            for (let i = 0; i < mediaList.length; i++) {
                urlList.push(mediaList[i].url)
                if (mediaList[i].type.startsWith("image")) {
                    imgCount++;
                }
                else if (mediaList[i].type.startsWith("video")) {
                    vidCount++;
                }
            }

            if(mediaList.length < 1){
                urlList.push(previewUrl);
            }

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            for (let i = 0; i < this.postListRaw.length; i++) {
                if (this.postListRaw[i].id == id) {
                    index = i;
                    this.postListRaw[i].fullName = userSnap.data().name;
                    this.postListRaw[i].userName = userSnap.data().displayId;
                    this.postListRaw[i].profilePic = userSnap.data().profilePic;
                    this.postListRaw[i].email = userSnap.data().email;
                    this.postListRaw[i].bundle1 = userSnap.data().bundle1;
                    this.postListRaw[i].bundle2 = userSnap.data().bundle2;
                    this.postListRaw[i].bundle3 = userSnap.data().bundle3;
                    this.postListRaw[i].sexuality = userSnap.data().sexuality;

                    this.postListRaw[i].urlList = urlList;
                    this.postListRaw[i].vidCount = vidCount;
                    this.postListRaw[i].imgCount = imgCount;

                    if (auth.currentUser.uid == userId) {
                        this.postListRaw[i].isOwner = true;
                        this.postListRaw[i].isSubscribed = true;
                    }
                    else if (userSnap.data().type == "user") {
                        this.postListRaw[i].isSubscribed = true;
                    }
                    else {
                        for (let i = 0; i < fanList.length; i++) {
                            if (fanList[i] == auth.currentUser.uid) {
                                this.postListRaw[index].isSubscribed = true;
                                break;
                            }
                        }
                    }

                    for (let i = 0; i < likedList.length; i++) {
                        if (likedList[i] == auth.currentUser.uid) {
                            this.postListRaw[index].isLiked = true;
                            break;
                        }
                    }

                    for (let i = 0; i < bookmarkList.length; i++) {
                        if (bookmarkList[i] == auth.currentUser.uid) {
                            this.postListRaw[index].isBookmarked = true;
                            break;
                        }
                    }

                    this.postListRaw[i].isLoading = false;

                    break;

                }


            }


        },

        async getFullName2(id, userId, mediaList, previewUrl, mIndex) {

            let i = mIndex;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            let urlList = [];
            let imgCount = 0;
            let vidCount = 0;

            for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                if (mediaList[a].type.startsWith("image")) {
                    imgCount++;
                }
                else if (mediaList[a].type.startsWith("video")) {
                    vidCount++;
                }
            }

            if(mediaList.length < 1){
                urlList.push(previewUrl);
            }

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            if (this.postListRaw2[i].id == id) {
                    
                    this.postListRaw2[i].fullName = userSnap.data().name;
                    this.postListRaw2[i].userName = userSnap.data().displayId;
                    this.postListRaw2[i].profilePic = userSnap.data().profilePic;
                    this.postListRaw2[i].email = userSnap.data().email;
                    this.postListRaw2[i].bundle1 = userSnap.data().bundle1;
                    this.postListRaw2[i].bundle2 = userSnap.data().bundle2;
                    this.postListRaw2[i].bundle3 = userSnap.data().bundle3;
                    this.postListRaw2[i].sexuality = userSnap.data().sexuality;
                    this.postListRaw2[i].userType = userSnap.data().type;
                    this.postListRaw2[i].profileType = userSnap.data().profileType;

                    this.postListRaw2[i].urlList = urlList;
                    this.postListRaw2[i].vidCount = vidCount;
                    this.postListRaw2[i].imgCount = imgCount;

                    if (auth.currentUser.uid == userId) {
                        this.postListRaw2[i].isOwner = true;
                        this.postListRaw2[i].isSubscribed = true;
                        this.postListRaw2[i].isPaid = true;
                    }
                    else if (userSnap.data().type == "user") {
                        this.postListRaw2[i].isSubscribed = true;
                    }
                    else if (userSnap.data().profileType == "free") {
                        this.postListRaw2[i].isSubscribed = true;
                    }
                    else {
                        for (let b = 0; b < fanList.length; b++) {
                            if (fanList[b] == auth.currentUser.uid) {
                                this.postListRaw2[i].isSubscribed = true;
                                break;
                            }
                        }
                    }

                    for (let c = 0; c < likedList.length; c++) {
                        if (likedList[c] == auth.currentUser.uid) {
                            this.postListRaw2[i].isLiked = true;
                            break;
                        }
                    }

                    for (let d = 0; d < bookmarkList.length; d++) {
                        if (bookmarkList[d] == auth.currentUser.uid) {
                            this.postListRaw2[i].isBookmarked = true;
                            break;
                        }
                    }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postListRaw2[i].isPaid = true;
                            break;
                        }
                    }

                    this.postListRaw2[i].isLoading = false;

                }

        },

        async getFullName3(id, userId, mediaList, previewUrl, mIndex) {

            let i = mIndex;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            let urlList = [];
            let imgCount = 0;
            let vidCount = 0;

            for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                if (mediaList[a].type.startsWith("image")) {
                    imgCount++;
                }
                else if (mediaList[a].type.startsWith("video")) {
                    vidCount++;
                }
            }

            if(mediaList.length < 1){
                urlList.push(previewUrl);
            }

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            if (this.postListRaw3[i].id == id) {
                    
                    this.postListRaw3[i].fullName = userSnap.data().name;
                    this.postListRaw3[i].userName = userSnap.data().displayId;
                    this.postListRaw3[i].profilePic = userSnap.data().profilePic;
                    this.postListRaw3[i].email = userSnap.data().email;
                    this.postListRaw3[i].bundle1 = userSnap.data().bundle1;
                    this.postListRaw3[i].bundle2 = userSnap.data().bundle2;
                    this.postListRaw3[i].bundle3 = userSnap.data().bundle3;
                    this.postListRaw3[i].sexuality = userSnap.data().sexuality;
                    this.postListRaw3[i].userType = userSnap.data().type;
                    this.postListRaw3[i].profileType = userSnap.data().profileType;

                    this.postListRaw3[i].urlList = urlList;
                    this.postListRaw3[i].vidCount = vidCount;
                    this.postListRaw3[i].imgCount = imgCount;

                    if (auth.currentUser.uid == userId) {
                        this.postListRaw3[i].isOwner = true;
                        this.postListRaw3[i].isSubscribed = true;
                        this.postListRaw3[i].isPaid = true;
                    }
                    else if (userSnap.data().type == "user") {
                        this.postListRaw3[i].isSubscribed = true;
                    }
                    else if (userSnap.data().profileType == "free") {
                        this.postListRaw3[i].isSubscribed = true;
                    }
                    else {
                        for (let b = 0; b < fanList.length; b++) {
                            if (fanList[b] == auth.currentUser.uid) {
                                this.postListRaw3[i].isSubscribed = true;
                                break;
                            }
                        }
                    }

                    for (let c = 0; c < likedList.length; c++) {
                        if (likedList[c] == auth.currentUser.uid) {
                            this.postListRaw3[i].isLiked = true;
                            break;
                        }
                    }

                    for (let d = 0; d < bookmarkList.length; d++) {
                        if (bookmarkList[d] == auth.currentUser.uid) {
                            this.postListRaw3[i].isBookmarked = true;
                            break;
                        }
                    }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postListRaw3[i].isPaid = true;
                            break;
                        }
                    }

                    this.postListRaw3[i].isLoading = false;

                }

        },

        async getFullName4(id, userId) {

            let index;
            let fanList = [];
            let likedList = [];
            let bookmarkList = [];
            let paidUsers = [];

            const auth = getAuth();
            const userRef = doc(db, "Users", userId);
            const userSnap = await getDoc(userRef);

            const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
            querySnapshot.forEach((doc) => {
                fanList.push(doc.id);
            });

            const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
            querySnapshot2.forEach((doc) => {
                likedList.push(doc.id);
            });

            const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
            querySnapshot3.forEach((doc) => {
                bookmarkList.push(doc.id);
            });

            const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
            querySnapshot4.forEach((doc) => {
                paidUsers.push(doc.id);
            });

            for (let i = 0; i < this.postListRaw4.length; i++) {
                if (this.postListRaw4[i].id == id) {
                    index = i;
                    this.postListRaw4[i].fullName = userSnap.data().name;
                    this.postListRaw4[i].userName = userSnap.data().displayId;
                    this.postListRaw4[i].profilePic = userSnap.data().profilePic;
                    this.postListRaw4[i].email = userSnap.data().email;
                    this.postListRaw4[i].bundle1 = userSnap.data().bundle1;
                    this.postListRaw4[i].bundle2 = userSnap.data().bundle2;
                    this.postListRaw4[i].bundle3 = userSnap.data().bundle3;
                    this.postListRaw4[i].sexuality = userSnap.data().sexuality;
                    this.postListRaw4[i].profileType = userSnap.data().profileType;

                    if (auth.currentUser.uid == userId) {
                        this.postListRaw4[i].isOwner = true;
                        this.postListRaw4[i].isSubscribed = true;
                        this.postListRaw4[i].isPaid = true;
                    }
                    else if (userSnap.data().type == "user") {
                        this.postListRaw4[i].isSubscribed = true;
                    }
                    else if (userSnap.data().profileType == "free") {
                        this.postListRaw4[i].isSubscribed = true;
                    }
                    else {
                        for (let i = 0; i < fanList.length; i++) {
                            if (fanList[i] == auth.currentUser.uid) {
                                this.postListRaw4[index].isSubscribed = true;
                                break;
                            }
                        }
                    }

                    for (let i = 0; i < likedList.length; i++) {
                        if (likedList[i] == auth.currentUser.uid) {
                            this.postListRaw4[index].isLiked = true;
                            break;
                        }
                    }

                    for (let i = 0; i < bookmarkList.length; i++) {
                        if (bookmarkList[i] == auth.currentUser.uid) {
                            this.postListRaw4[index].isBookmarked = true;
                            break;
                        }
                    }

                    for (let e = 0; e < paidUsers.length; e++) {
                        if (paidUsers[e] == auth.currentUser.uid) {
                            this.postListRaw4[i].isPaid = true;
                            break;
                        }
                    }

                }

            }

        },

    },

}

</script>